module.exports = "<p>\r\n  lock works!\r\n</p>\r\n"